import { PaginatorInput } from '@shared/components/paginator/models/paginator-input.model';

import {
  DraftListing,
  ProcedureListing,
  ProceduresListingFilters,
  ProceduresListingTab,
} from '@core/domain/model/procedures/procedures-listing.model';

export type ProceduresListingState = {
  pagination: PaginatorInput;
  filters: ProceduresListingFilters;
  data: DraftListing[] | ProcedureListing[] | null;
  error: string | null;
  type: ProceduresListingTab | null;
};

export const proceduresListingInitialState: ProceduresListingState = {
  pagination: {
    pageIndex: 1,
    pageSize: 5,
  },
  filters: {},
  data: null,
  error: null,
  type: null,
};
